export default "__VITE_ASSET__DR3HprN6__"